/** Every cache key in one place, so an invalidation can be read against its writer. */
export const qk = {
	me: ['me'] as const,
	/** The same question asked without making a guest (sign-in, register): its own answer, never the app's. */
	meNoGuest: ['me', 'no-guest'] as const,
	providers: ['providers'] as const,
	/** Work a guest left in this browser, offered to the teacher who signed in: null once answered. */
	pendingGuest: ['pending-guest'] as const,
	artifacts: ['artifacts'] as const,
	artifact: (id: string) => ['artifact', id] as const,
	contextSuggestion: (id: string) => ['artifact', id, 'context-suggestion'] as const,
	/** Her text read aloud; `body` is in the key so a saved edit asks again (the server says if it is stale). */
	artifactAudio: (id: string, body: string) => ['artifact', id, 'audio', body] as const,
	activities: ['activities'] as const,
	activity: (id: string) => ['activity', id] as const,
	/** The prefix of every results query of one activity, whatever group it is filtered to. */
	results: (id: string) => ['results', id] as const,
	resultsFor: (id: string, assignment: string | undefined) =>
		['results', id, assignment ?? 'all'] as const,
	resultsHub: ['results-hub'] as const,
	assignments: (activityId: string) => ['activity', activityId, 'assignments'] as const,
	groups: ['groups'] as const,
	levels: (artifactId: string) => ['artifact', artifactId, 'levels'] as const,
	plans: (artifactId: string) => ['artifact', artifactId, 'plans'] as const,
	plan: (id: string) => ['plan', id] as const,
	allPlans: ['lesson-plans'] as const,
	folders: ['folders'] as const,
	/** A teacher's preview of her own activity: never kept, so it is always her latest edit. */
	preview: (activityId: string) => ['preview', activityId] as const,
	learner: (slug: string) => ['learner', slug] as const,
	attemptResult: (slug: string, attemptId: string) =>
		['learner', slug, 'result', attemptId] as const,
	wordLists: ['word-lists'] as const,
	wordList: (id: string) => ['word-list', id] as const,
	wordResults: (id: string) => ['word-results', id] as const,
	publicWords: (slug: string) => ['public-words', slug] as const,
}
